actions =
  setUuid: (context, uuid) ->
    new Promise (resolve, reject) ->
      context.commit('uuid', uuid)
      resolve()

`export default actions`
